import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      
      <div className="pt-24 pb-16">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl">
          <div className="bg-white rounded-3xl shadow-lg border border-slate-200 p-8 md:p-12">
            <h1 className="text-3xl md:text-4xl font-bold text-[#0f172a] mb-8" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Terms of Service
            </h1>
            
            <div className="prose prose-slate max-w-none">
              <p className="text-slate-600 mb-6">
                <strong>Last Updated:</strong> March 2026
              </p>
              
              <p className="text-slate-600 mb-6">
                Welcome to Local Tradies Online. By accessing or using our website localtradiesonline.com.au, you agree to be bound by these Terms of Service. Please read them carefully.
              </p>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">1. Acceptance of Terms</h2>
              <p className="text-slate-600 mb-4">
                By accessing and using this website, you accept and agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree to these terms, please do not use our website.
              </p>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">2. Description of Service</h2>
              <p className="text-slate-600 mb-4">
                Local Tradies Online is an online directory that connects customers with local tradies and tradespeople across Australia. We provide a platform for:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-4">
                <li>Customers to search for and contact tradies</li>
                <li>Customers to request quotes for services</li>
                <li>Tradies to list their services and business details</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">3. User Responsibilities</h2>
              
              <h3 className="text-xl font-semibold text-[#0f172a] mt-6 mb-3">For Customers</h3>
              <ul className="list-disc pl-6 text-slate-600 mb-4">
                <li>Provide accurate information when submitting quote requests</li>
                <li>Use the service for legitimate purposes only</li>
                <li>Conduct your own due diligence when selecting a tradie</li>
                <li>Negotiate and agree on terms directly with tradies</li>
              </ul>

              <h3 className="text-xl font-semibold text-[#0f172a] mt-6 mb-3">For Tradies</h3>
              <ul className="list-disc pl-6 text-slate-600 mb-4">
                <li>Provide accurate and up-to-date business information</li>
                <li>Hold all necessary licences and insurance for your trade</li>
                <li>Respond to customer enquiries professionally and promptly</li>
                <li>Comply with all applicable Australian laws and regulations</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">4. Disclaimer</h2>
              <p className="text-slate-600 mb-4">
                <strong>Important:</strong> Local Tradies Online is a directory service only. We do not:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-4">
                <li>Employ or contract any tradies listed on our platform</li>
                <li>Guarantee the quality of work performed by any tradie</li>
                <li>Verify licences, insurance, or qualifications (unless marked as "Verified")</li>
                <li>Provide warranties for any services rendered</li>
                <li>Act as an intermediary in disputes between customers and tradies</li>
              </ul>
              <p className="text-slate-600 mb-4">
                We strongly recommend that customers verify a tradie's licences, insurance, and references before engaging their services.
              </p>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">5. Limitation of Liability</h2>
              <p className="text-slate-600 mb-4">
                To the maximum extent permitted by law, Local Tradies Online shall not be liable for:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-4">
                <li>Any direct, indirect, incidental, or consequential damages arising from the use of our service</li>
                <li>The actions, conduct, or quality of work of any tradie listed on our platform</li>
                <li>Any disputes between customers and tradies</li>
                <li>Loss of data, profits, or business opportunities</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">6. Intellectual Property</h2>
              <p className="text-slate-600 mb-4">
                All content on this website, including text, graphics, logos, and software, is the property of Local Tradies Online or its content suppliers and is protected by Australian and international copyright laws.
              </p>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">7. User Content</h2>
              <p className="text-slate-600 mb-4">
                By submitting content to our website (including business listings and reviews), you grant us a non-exclusive, royalty-free licence to use, display, and distribute that content on our platform.
              </p>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">8. Prohibited Conduct</h2>
              <p className="text-slate-600 mb-4">You agree not to:</p>
              <ul className="list-disc pl-6 text-slate-600 mb-4">
                <li>Use the service for any unlawful purpose</li>
                <li>Submit false or misleading information</li>
                <li>Impersonate another person or business</li>
                <li>Interfere with the proper functioning of the website</li>
                <li>Scrape or harvest data from our website without permission</li>
                <li>Post spam, advertisements, or promotional material</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">9. Termination</h2>
              <p className="text-slate-600 mb-4">
                We reserve the right to terminate or suspend access to our service immediately, without prior notice, for any reason, including breach of these Terms of Service.
              </p>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">10. Governing Law</h2>
              <p className="text-slate-600 mb-4">
                These Terms of Service are governed by and construed in accordance with the laws of Australia. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of Australian courts.
              </p>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">11. Changes to Terms</h2>
              <p className="text-slate-600 mb-4">
                We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to the website. Your continued use of the service constitutes acceptance of the modified terms.
              </p>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">12. Contact Us</h2>
              <p className="text-slate-600 mb-4">
                If you have any questions about these Terms of Service, please contact us at:
              </p>
              <p className="text-slate-600 mb-4">
                <strong>Email:</strong> legal@localtradiesonline.com.au<br />
                <strong>Phone:</strong> 0431 775 771
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
